// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-panel {
    width: 240px;
    min-width: 240px; 
    background-color: var(--clr-white);
    border-right: 2px solid var(--clr-primary-5);
    padding: 1rem;
    transition: var(--transition);
    box-sizing: border-box;
    flex-shrink: 0;
  }
  
  .tab-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .tab-button {
    background-color: transparent;
    border: none;
    padding: 0.75rem 1rem;
    text-align: left;
    color: var(--clr-primary-3);
    font-size: 1rem;
    cursor: pointer;
    transition: var(--transition);
    border-radius: var(--radius);
  }
  
  .tab-button:hover,
  .tab-button.active {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
  }
  
  .hamburger-btn {
    display: none;
    background-color: var(--red-dark);
    color: var(--clr-white);
    border: none;
    padding: 0.5rem;
    font-size: 1.25rem;
    border-radius: 4px;
    margin-bottom: 1rem;
    cursor: pointer;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .side-panel {
      width: 100%;
      display: none;
      flex-direction: column;
      background-color: var(--clr-primary-10);
      border-right: none;
    }
  
    .side-panel.open {
      display: flex;
    }
  
    .hamburger-btn {
      display: block;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Configurations/SidePanel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,4CAA4C;IAC5C,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;;IAEE,sCAAsC;IACtC,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;MACE,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,uCAAuC;MACvC,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;EACF","sourcesContent":[".side-panel {\n    width: 240px;\n    min-width: 240px; \n    background-color: var(--clr-white);\n    border-right: 2px solid var(--clr-primary-5);\n    padding: 1rem;\n    transition: var(--transition);\n    box-sizing: border-box;\n    flex-shrink: 0;\n  }\n  \n  .tab-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .tab-button {\n    background-color: transparent;\n    border: none;\n    padding: 0.75rem 1rem;\n    text-align: left;\n    color: var(--clr-primary-3);\n    font-size: 1rem;\n    cursor: pointer;\n    transition: var(--transition);\n    border-radius: var(--radius);\n  }\n  \n  .tab-button:hover,\n  .tab-button.active {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n  }\n  \n  .hamburger-btn {\n    display: none;\n    background-color: var(--red-dark);\n    color: var(--clr-white);\n    border: none;\n    padding: 0.5rem;\n    font-size: 1.25rem;\n    border-radius: 4px;\n    margin-bottom: 1rem;\n    cursor: pointer;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .side-panel {\n      width: 100%;\n      display: none;\n      flex-direction: column;\n      background-color: var(--clr-primary-10);\n      border-right: none;\n    }\n  \n    .side-panel.open {\n      display: flex;\n    }\n  \n    .hamburger-btn {\n      display: block;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
